import { Alert } from "reactstrap";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import { useTranslation } from "react-i18next";

function IntegrationsPage() {
  const { t } = useTranslation();
  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('settings.integrations')} />

        <div className="subheader-page-content scrollable">
          <Alert color="info">
            {t('settings.integrationsMessage')}
          </Alert>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default IntegrationsPage;
